import {
  ChangeDetectorRef,
  Component,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { merge, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

import { FuseNavigationItem } from "@fuse/types";
import { FuseNavigationService } from "@fuse/components/navigation/navigation.service";

import { CompanyService } from "app/services/company.service";
@Component({
  selector: "fuse-nav-vertical-group",
  templateUrl: "./group.component.html",
  styleUrls: ["./group.component.scss"],
})
export class FuseNavVerticalGroupComponent implements OnInit, OnDestroy {
  @HostBinding("class")
  classes = "nav-group nav-item";

  @Input()
  item: FuseNavigationItem;

  // Private
  private _unsubscribeAll: Subject<any>;
  companyId: any;
  companySubscription: any;
  companyData: any;

  /**
   * Constructor
   */

  /**
   *
   * @param {ChangeDetectorRef} _changeDetectorRef
   * @param {FuseNavigationService} _fuseNavigationService
   */
  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _fuseNavigationService: FuseNavigationService,
    private comSer: CompanyService
  ) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  navigationChangeOnTeamMemberLimit() {
    const loginUserId = JSON.parse(localStorage.getItem("loginUserId"));
    this.comSer.getCompanyDetail(loginUserId).subscribe((companyResponse) => {
      if (companyResponse.response == 200) {
        this.companyData = companyResponse.object.content[0];
        this.companySubscription = this.companyData.user.subscription;  
        if (this.companyData.user.subscription != null) {
          this.item.children.forEach((element) => {
            if (element.id === "teamMembers") {
              if (this.companySubscription.teamMemberLimit < 1) {
                this._fuseNavigationService.updateNavigationItem("teamMembers",{hidden: false,});
              } else {
                this._fuseNavigationService.updateNavigationItem(
                  "teamMembers",
                  {
                    hidden: false,
                  }
                );
              }
            }
          });
        } else {
          this._fuseNavigationService.updateNavigationItem("teamMembers", {
            hidden: true,
          });
        }
      }
    });
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    this.navigationChangeOnTeamMemberLimit();

    // Subscribe to navigation item
    merge(
      this._fuseNavigationService.onNavigationItemAdded,
      this._fuseNavigationService.onNavigationItemUpdated,
      this._fuseNavigationService.onNavigationItemRemoved
    )
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(() => {
        // Mark for check
        this._changeDetectorRef.markForCheck();
      });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}
